import TheGrid from '@/views/campaigns/bestof/campaigntypes/grid'
import Edit from '@/views/campaigns/bestof/campaigntypes/edit'

export default {
  path: '/campaigns/bestof/campaigntypes',
  redirect: '/campaigns/bestof/campaigntypes/index',
  name: 'Bestoftypes',
  meta: {
    auth: {
      redirect: {
        name: 'Bestoftypes.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bestoftypes'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'Bestoftypes.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'Bestoftypes.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'Bestoftypes.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
